export type SubscriptionTier = 'free' | 'pro' | 'business' | 'enterprise';

export interface RetentionConfig {
  expiresAt: string | null;
  savedPermanently: boolean;
  retentionPolicy: string;
  displayText: string;
  daysRetention: number | null;
}

export const getRetentionConfig = (tier: SubscriptionTier, isAutoSave: boolean = true): RetentionConfig => {
  const now = Date.now();

  switch (tier) {
    case 'business':
    case 'enterprise':
      return {
        expiresAt: null,
        savedPermanently: true,
        retentionPolicy: 'permanent',
        displayText: 'Saved permanently',
        daysRetention: null,
      };
    case 'pro':
      return {
        expiresAt: new Date(now + 60 * 24 * 60 * 60 * 1000).toISOString(),
        savedPermanently: false,
        retentionPolicy: 'pro_60_days',
        displayText: 'Saved for 60 days',
        daysRetention: 60,
      };
    case 'free':
    default:
      return {
        expiresAt: new Date(now + 7 * 24 * 60 * 60 * 1000).toISOString(),
        savedPermanently: false,
        retentionPolicy: isAutoSave ? 'auto_7_days' : 'free_7_days',
        displayText: isAutoSave ? 'Auto-saved for 7 days' : 'Saved for 7 days',
        daysRetention: 7,
      };
  }
};
